import React from 'react';
import { observer } from 'mobx-react';
import { Table } from 'antd';
import { Catcher, viewOption } from '../../';
import { ShowRateItem } from './ShowRateItem';
import { ShowRateZoneTableDataType } from './ShowRateZoneTableV2';
import cx from 'classnames';
import { IRateListRespEntryV2 } from '../../../interfaces';
import { tF } from '../../../translate';
import StylesItem from '../m_styles.less';

export interface IShowRateCountryNetworksTableV2 {
    record: ShowRateZoneTableDataType;
}

const tableColumns = [
    {
        title: tF('Network'),
        dataIndex: 'network',
        className: StylesItem.rateColumnCountry,
        width: viewOption.rateTable.widthRateCountry,
    },
    {
        title: tF('Increment Data'),
        dataIndex: 'incrementDataShow',
        className: StylesItem.rateColumnVal,
        width: viewOption.rateTable.widthRateVal,
    },
    {
        title: tF('Data'),
        dataIndex: 'rateDataShow',
        className: StylesItem.rateColumnVal,
        width: viewOption.rateTable.widthRateVal,
    },
    {
        title: tF('SMS'),
        dataIndex: 'rateSmsShow',
        className: StylesItem.rateColumnVal,
        width: viewOption.rateTable.widthRateVal,
    },
    {
        title: tF('Voice Mobile'),
        dataIndex: 'rateVoiceMobileShow',
        className: StylesItem.rateColumnVal,
        width: viewOption.rateTable.widthRateVal,
    },
    {
        title: tF('Voice Fix Net'),
        dataIndex: 'rateVoiceNetShow',
        className: StylesItem.rateColumnVal,
        width: viewOption.rateTable.widthRateVal,
    },
];

export const ShowRateCountryNetworksTableV2: React.FC<IShowRateCountryNetworksTableV2> = observer(
    ({ record: { countryRates, countryRate } }: IShowRateCountryNetworksTableV2) => {
        const tableData = countryRates.map((network: IRateListRespEntryV2) => {
            return {
                key: network.id,
                network: network.networkName,
                incrementDataShow: <span className={StylesItem.defaultRate}>{network?.incrementData}</span>,
                rateDataShow: (
                    <ShowRateItem
                        calculatedRate={network?.calculatedRateData}
                        calculatedRateParent={countryRate?.calculatedRateData}
                        currency={countryRate?.currency}
                        rate={network?.rateData}
                        rateUnitId={network?.rateDataUnitId}
                    />
                ),
                rateSmsShow: (
                    <ShowRateItem
                        calculatedRate={network?.calculatedRateSms}
                        calculatedRateParent={countryRate?.calculatedRateSms}
                        currency={countryRate?.currency}
                        rate={network?.rateSms}
                        rateUnitId={network?.rateSmsUnitId}
                    />
                ),
                rateVoiceMobileShow: (
                    <ShowRateItem
                        calculatedRate={network?.calculatedRateVoiceMobile}
                        calculatedRateParent={countryRate?.calculatedRateVoiceMobile}
                        currency={countryRate?.currency}
                        rate={network?.rateVoiceMobile}
                        rateUnitId={network?.rateVoiceMobileUnitId}
                    />
                ),
                rateVoiceNetShow: (
                    <ShowRateItem
                        calculatedRate={network?.calculatedRateVoiceNet}
                        calculatedRateParent={countryRate?.calculatedRateVoiceNet}
                        currency={countryRate?.currency}
                        rate={network?.rateVoiceNet}
                        rateUnitId={network?.rateVoiceNetUnitId}
                    />
                ),
            };
        });

        return (
            <Catcher>
                <Table
                    className={cx('table-theme')}
                    columns={tableColumns}
                    dataSource={tableData}
                    pagination={false}
                    size={'small'}
                />
            </Catcher>
        );
    },
);
